import styled from 'styled-components'
import Text from './Text'

const Bold = styled(Text)`
  font-weight: bold;
`

export default Bold
